<template>
  	<div class="stores">
    	<div class="breadcrumb">用户管理 > 添加用户</div>
    	<div class="searchBtn" style="border:none;display:flex">
	      	<el-button size='small' type="primary" @click="add" plain>添加</el-button>
	      	<el-button size='small' type="warning" @click="edit" plain>修改</el-button>
	      	<el-button size='small' type="danger" @click="del" plain>删除</el-button>
	      	<div class="topinput">
				<input type="text" placeholder="请输入昵称" class="el-input__inner" v-model="nickname" @keyup.enter="search_mine()"/>
			</div>
			<div class="topinput">
				<input type="text" placeholder="请输入手机号" class="el-input__inner" v-model="mobile" @keyup.enter="search_mine()"/>
			</div>
			<el-button type="primary" @click="search_mine()" style="margin-left:15px">搜索</el-button>
    	</div>
    	<div class="main">
	      	<template>
	        	<el-table
	          		ref="multipleTable"
	          		:data="tableData"
	          		highlight-current-row
	          		tooltip-effect="dark"
	          		style="width: 100%"
	          		@current-change="handleCurrentChange">
		          	<el-table-column prop="id"  label="ID"></el-table-column>
		          	<el-table-column prop="mobile"  label="手机号" show-overflow-tooltip></el-table-column>
		          	<el-table-column prop="nickname" label="昵称" show-overflow-tooltip></el-table-column>
		          	<el-table-column
		            	prop="sex"
		            	label="性别"
		            	:formatter="this.global.formatRole"
		            	show-overflow-tooltip
		          	></el-table-column>
		          	<el-table-column prop="age" label="年龄" show-overflow-tooltip></el-table-column>
		          	<!-- <el-table-column prop="photo" align="center" label="头像">
		            <template scope="scope">
		              <img :src="scope.row.photo" width="50" height="50" />
		            </template>
		          	</el-table-column> -->
		          	<el-table-column
			            prop="createTime"
			            :formatter="this.global.dateFormat"
			            label="创建时间"
		          	></el-table-column>
	        	</el-table>
	      	</template>
      		<div class="block" style="padding:30px 10px; float:right">
	        	<el-pagination
		          	@current-change="handleCurrentChangePage"
		          	:current-page="pageNum"
		          	:page-size="limit"
		          	layout="total, prev, pager, next, jumper"
		          	:total="totalPage"
	        	></el-pagination>
      		</div>
    	</div>
    	<!-- 弹框 -->
    	<el-dialog title="提示" :visible.sync="dialogVisible" width="35%" :before-close="handleClose">
      		<el-form :model="ruleForm" ref="ruleForm" :rules="ruleForms" status-icon label-width="120px">
        		<el-form-item label="手机号" prop="mobile">
          			<el-input v-model="ruleForm.mobile" placeholder="请输入手机号" readonly onfocus="this.removeAttribute('readonly');" style="width: 80%;"></el-input>
        		</el-form-item>
        		<el-form-item label="密码" prop="password">
          			<el-input v-model="ruleForm.password" type="password" placeholder="默认不显示，要更新请输入新密码" readonly onfocus="this.removeAttribute('readonly');" style="width: 80%;"></el-input>
        		</el-form-item>
        		<el-form-item label="昵称" prop="nickname">
          			<el-input v-model="ruleForm.nickname" placeholder="请输入昵称" style="width: 80%;"></el-input>
        		</el-form-item>
        		<el-form-item label="性别" prop="sex">
          			<input type="hidden" v-model="ruleForm.sex" />
          			<el-select v-model="ruleForm.sexname" placeholder="请选择性别" style="width: 80%;" @change="rulesex">
            			<el-option label="未知" value="-1"></el-option>
            			<el-option label="男" value="0"></el-option>
            			<el-option label="女" value="1"></el-option>
          			</el-select>
        		</el-form-item>

        		<el-form-item label="身高（cm）" prop="height">
          			<el-input v-model="ruleForm.height" placeholder="请输入身高" style="width: 80%;"></el-input>
        		</el-form-item>
        		<el-form-item label="体重（kg）" prop="weight">
          			<el-input v-model="ruleForm.weight" placeholder="请输入体重" style="width: 80%;"></el-input>
        		</el-form-item>
        		<!-- 上传图片 -->
        		<el-form-item label="上传头像" prop="photo">
          			<el-input v-model="ruleForm.photo" placeholder style="width: 80%;"></el-input>
          			<el-upload
            			class="avatar-uploader"
			            :action="tmpFiles"
			            :show-file-list="false"
			            :headers="headers"
			            :on-success="handleAvatarSuccess"
			            :before-upload="beforeAvatarUpload"
          			>
	            		<img v-if="ruleForm.photo" :src="ruleForm.photo" class="avatar" />
	            		<i v-else class="el-icon-plus avatar-uploader-icon"></i>
          			</el-upload>
        		</el-form-item>
        		<el-form-item label="生日" prop="birthday">
          			<el-date-picker v-model="ruleForm.birthday" type="date" placeholder="选择日期" style="width: 80%;"></el-date-picker>
        		</el-form-item>
        		<!-- <el-form-item label="选择门店">
                	<input type="hidden" v-model="ruleForm.storeId">
          			<el-select v-model="ruleForm.storeName" placeholder="请选择门店" style="width: 80%;" @change="rulestoreName">
	            		<el-option
	              			v-for="item in tableData2"
	              			:key="item.id"
	              			:label="item.name"
	              			:value="item.id"
	            		>{{item.name}}</el-option>
          			</el-select>
        		</el-form-item> -->

        		<el-form-item label prop="id" v-show="isShow">
          			<el-input v-model="ruleForm.id" placeholder></el-input>
        		</el-form-item>
      		</el-form>
      		<span slot="footer" class="dialog-footer">
        		<el-button @click="dialogVisible = false">取 消</el-button>
        		<el-button type="primary" @click="onSubmit()">确 定</el-button>
      		</span>
    	</el-dialog>
  	</div>
</template>

<script>
export default {
  	components: {},
  	mounted() {
    	this.init();
  	},
  	data() {
    	return {
      		headers: {
        		xqiao_token: localStorage.getItem("token")
      		},
	      	tmpFiles: process.env.API_ROOT + "/tmpFiles",
	      	tableData2: [], //选择门店
	      	tableData: [],
	      	nickname:'',
	      	mobile:'',
	      	pageNum: 1,
	      	limit: 10,
	      	totalPage: 10,
	      	currentRow: "",
	      	ruleForm: {
		        mobile: "",
		        password: "",
		        nickname: "",
		        sex: "",
		        height: "",
		        weight: "",
		        photo: "",
		        birthday: "",
		        id: ""
	      	},
	      	ruleForms: {
		        mobile: [{ required: true, message: "请输入手机号" }],
		        nickname: [{ required: true, message: "请输入昵称" }],
		        photo: [{ required: true, message: "请选择头像" }]
	      	},
	      	dialogVisible: false,
	      	isShow: false
    	};
  	},
  	methods: {
    	//初始化表格数据
    	init() {
      		var params = {
        		pageNum: this.pageNum,
        		limit: this.limit,
        		nickname:this.nickname,
        		mobile:this.mobile
      		};
      		this.$get("/users", params)
        	.then(res => {
          		if (res.code == 0) {
            		this.tableData = res.data.list;
            		this.totalPage = res.data.total;
          		} else {
            		this.$message({
              			message: res.message,
              			type: "warning"
            		});
            		return false;
          		}
        	})
        	.catch(() => {
          		console.log();
        	});
    	},
    	search_mine(){
    		this.init();
    	},
	    rulesex(val){
	      	this.ruleForm.sex=val;
	    },
      	rulestoreName(val){
        	this.ruleForm.storeId=val;
      	},
	    //当前页数
	    handleCurrentChangePage(val) {
	      	this.pageNum = val;
	      	this.init();
	    },
    	//弹框关闭按钮
    	handleClose(done) {
	      	if (this.$refs.ruleForm != undefined) {
	        	this.$refs.ruleForm.resetFields();
	      	}
	      	done();
    	},
    	//选择需要修改的权限
    	handleCurrentChange(val) {
      		if (val) {
        		this.currentRow = val.id;
      		}
    	},
    	//选择门店
    	selectStores() {
      		var params = {
		        pageNum: 1,
		        limit: 20
      		};
      		this.$get("/stores", params)
        	.then(res => {
          		if (res.code == 0) {
            		this.tableData2 = res.data.list;
          		} else {
            		this.$message({
              			message: res.message,
              			type: "warning"
            		});
            		return false;
          		}
        	})
	        .catch(() => {
	          	console.log();
	        });
    	},
    	//添加
	    add(row) {
        	this.$refs.multipleTable.setCurrentRow(row);
	      	if (this.$refs["ruleForm"]) {
	        	this.$refs["ruleForm"].resetFields();
	      	}
          	this.currentRow='';
	      	this.dialogVisible = true;
	      	// this.selectStores();
	    },
    	onSubmit() {
	      	//var that = this;
	      	//通过表单id判断，如果id有值为修改，否则是添加
	      	if (this.currentRow) {
	        	this.$refs.ruleForm.validate(valid => {
		          	if (valid) {
		            	this.loading = true;
		            	this.$axios.put("/users/" + this.ruleForm.id, JSON.stringify(this.ruleForm))
		              	.then(res => {
		                	this.loading = false;
		                	if (res.data.code == 0) {
		                  		this.$message({
		                    		message: "修改成功",
		                    		type: "success"
		                  		});
		                  		this.pageNum = 1;
		                  		this.currentRow='';
		                  		this.init();
		                  		this.dialogVisible = false;
		                	} else {
		                  		this.$message({
		                    		message: res.data.message,
		                    		type: "warning"
		                  		});
		                  		return false;
		                	}
		              	})
		              	.catch(() => {
		                	this.loading = false;
		              	});
		          	} else {
		            	console.log("error submit!!");
		            	return false;
		          	}
	        	});
	      	} else {
	        	console.log("添加");
	        	this.$refs.ruleForm.validate(valid => {
	          		if (valid) {
	            		this.loading = true;
	            		this.$post("/users", JSON.stringify(this.ruleForm))
	              		.then(res => {
                      		console.log(res)
	                		this.loading = false;
	                		if (res.code == 0) {
	                  			this.$message({
	                    			message: "添加成功",
	                    			type: "success"
	                  			});
	                  			this.$refs.ruleForm.resetFields();
	                  			this.pageNum = 1;
	                  			this.currentRow='';
	                  			this.init();
	                  			this.dialogVisible = false;
	                		} else {
	                  			this.$message({
	                    			message: res.message,
	                    			type: "warning"
	                  			});
	                  			return false;
	                		}
	              		})
	              		.catch(() => {
	                		this.loading = false;
	              		});
	          		} else {
			            console.log("error submit!!");
			            return false;
	          		}
	        	});
	      	}
    	},
    	edit() {
      		// this.selectStores();
      		var currentRowId = this.currentRow;
      		console.log(currentRowId);
      		if (currentRowId) {
        		this.$get("/users/" + currentRowId)
          		.then(res => {
            		if (res.code == 0) {
              			this.dialogVisible = true;
              			this.$nextTick(function() {
                			this.ruleForm = res.data;
                			this.ruleForm.sexname=res.data.sex==0?'男':res.data.sex==1?'女':'未知'
              			});
		              	// this.ruleForm.coachId=currentRowId;
		              	// this.ruleForm.mobile=res.data.mobile;
		              	// this.ruleForm.password=res.data.password;
		              	// this.ruleForm.nickname=res.data.nickname;
		              	// this.ruleForm.sex=res.data.sex;
		              	// this.ruleForm.height=res.data.height;
		              	// this.ruleForm.weight=res.data.weight;
		              	// this.ruleForm.photo=res.data.photo;
		              	// this.ruleForm.birthday=res.data.birthday;
            		}
          		})
          		.catch(() => {});
      		}else {
	        	this.dialogVisible = false;
		        this.$message({
		          	message: "请选择信息",
		          	type: "warning"
		        });
        		return false;
      		}
    	},
    	del() {
      		var that = this;
      		var currentRowId = that.currentRow;
      		if (currentRowId) {
        		that.$confirm("确定要删除吗?", "提示", {
		            confirmButtonText: "确定",
		            cancelButtonText: "取消",
		            type: "warning"
          		})
          		.then(() => {
            		that.$axios.delete("/users/" + currentRowId)
              		.then(function(res) {
                		console.log(res);
                		if (res.data.code == 0) {
                  			console.log(" 删除成功 ");
			                that.$message({
			                    message: "删除成功",
			                    type: "success"
			                });
                  			that.pageNum = 1;
                  			that.currentRow='';
                  			that.init();
                  			that.dialogVisible = false;
                		} else {
                  			that.errorMsg("操作失败");
                		}
              		})
              		.catch(function(err) {
                		console.log(err);
              		});
          		})
          		.catch(() => {});
      		} else {
        		this.$message({
          			message: "请选择信息",
          			type: "warning"
        		});
        		return false;
      		}
    	},
    	//选择图片成功
    	handleAvatarSuccess(res, file) {
      		console.log(res);
      		this.ruleForm.photo = res.data.url;
    	},
    	beforeAvatarUpload(file) {
          	console.log(file)
	      	const isJPG = file.type === "image/png" || file.type === "image/jpeg";
	      	const isLt2M = file.size / 1024 / 1024 < 2;

	      	if (!isJPG) {
	        	this.$message.error("上传头像图片只能是 JPG 格式 或者 PNG 格式!");
	      	}
	      	if (!isLt2M) {
	        	this.$message.error("上传头像图片大小不能超过 2MB!");
	      	}
	      	return isJPG && isLt2M;
    	}
  	}
};
</script>

<style scoped>
::deep
.avatar-uploader-icon {
    width: 108px;
    line-height: 108px
}
.selectUser {
  	color: #409eff;
}
.selectUser label,
.selectUser i {
  	font-size: 12px;
}
.topinput{
	position: relative;
	margin-left: 15px;
	width: 250px
}
.topinput input{
	font-size: 13px;
}
</style>



// WEBPACK FOOTER //
// src/views/usersList/index.vue